import React, { Fragment, useContext } from "react"
import { LoadingContext } from "../context/LoadingContext"
import ImageBanner from "../../images/privacypolicy/privacypolicybanner.png"
import i18n from "i18next"

const BannerPrivacyPolicy = () => {
  const { windowWidth } = useContext(LoadingContext)

  return (
    <Fragment>
      <div className="">
        <div className="shared-banner-container">
          {windowWidth >= 1025 ? (
            <div className="flex mobile:flex-col-reverse desktop:flex-row bannerPrincipal">
              <div className="shared-banner-content-btn m-4 desktop:mt-4 mobile:mt-16">
                <div className="flex flex-col txt-our-adn txt-our-adn-movil">
                  <h3 className="inline-block desktop:w-10/12 desktop:text-left mobile:text-left mb-4 mobile:mx-2 desktop:mx-24">
                    <span className="textTalentATS">
                      <p className="colorTextExperience2">{i18n.t("PrivacyPolicy.BannerPrivacyPolicy1")}</p>
                      <p className="colorTextExperience2">{i18n.t("PrivacyPolicy.BannerPrivacyPolicy2")}</p>
                    </span>
                  </h3>
                </div>
              </div>
              <div className="shared-banner-imageHome mobile:ml-0">
                <div className="bannerAcademyContentStyle">
                  <img
                    src={ImageBanner}
                    alt="Imagen PopUp"
                    className="imgBannerExperience"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="flex desktop:flex-row bannerPrincipalMobile">
              <div className="shared-banner-content-btn m-4 desktop:mt-4 mobile:mt-16">
                <div className="flex flex-col txt-our-adn txt-our-adn-movil">
                  <h3 className="inline-block desktop:w-10/12 desktop:text-left mobile:text-left mb-4 mobile:mx-2 desktop:mx-24">
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                    <span className="textTalentATS">
                      <p className="colorTextExperience2">{i18n.t("PrivacyPolicy.BannerPrivacyPolicy1")}</p>
                      <p className="colorTextExperience2">{i18n.t("PrivacyPolicy.BannerPrivacyPolicy2")}</p>
                    </span>
                    <br></br>
                    <br></br>
                    <br></br>
                    <br></br>
                  </h3>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  )
}

export default BannerPrivacyPolicy
